export const translations = {
  lv: {
    nav: {
      home: "Sākums",
      about: "Par mums",
      menu: "Ēdienkarte",
      wine: "Vīna karte",
      gallery: "Galerija",
      events: "Pasākumi",
      reviews: "Atsauksmes",
      contact: "Kontakti",
      reserve: "Rezervēt galdiņu",
    },
    hero: {
      eyebrow: "Itāļu vasaras restorāns Liepājā",
      title_1: "Restorāns",
      title_2: "Roze",
      tagline:
        "Itāļu virtuve ziedošā dārzā, dažus soļus no Baltijas jūras krasta — La dolce vita Liepājas vasarā.",
      cta_reserve: "Rezervēt galdiņu",
      cta_about: "Iepazīt vietu",
      season: "Atvērts no maija līdz septembrim",
    },
    home: {
      intro_overline: "Mūsu stāsts",
      intro_title: "Itāļu vasara Liepājas dārzā",
      intro_body_1:
        "Restorāns Roze atrodas pasakainā vietā – plašajā un ziedošajā Roze Boutique Hotel dārzā, vienā no skaistākajiem Liepājas stūrīšiem. Šovasar mūsu virtuve runā itāļu valodā.",
      intro_body_2:
        "Vasaras ēdienkartē – itāļu klasika ar autora pieskārienu: pasta uz vietas, krāsnī gatavota pica, riekstu trifeles un gaiši Vidusjūras vakari Latvijas debesīs.",
      intro_cta: "Vairāk par restorānu",
      highlights_overline: "Atmosfēra",
      highlights_title: "Itāļu garša Liepājas dārzā",
      highlights: [
        { title: "Ziedošs dārzs", body: "Mājīgi vasaras vakari rožu un zaļumu ielokā, klusi šalcošas strūklakas pavadībā." },
        { title: "Itāļu virtuve", body: "Mājās gatavota pasta, krāsnī cepta pica un Vidusjūras klasika." },
        { title: "Baltijas tuvums", body: "Pāris minūtes no jūras krasta un Liepājas saulrieta — kā Amalfi krasts ziemeļos." },
      ],
      cta_band_overline: "Rezervācija",
      cta_band_title: "Lūdzam pie galda",
      cta_band_body:
        "Mēs ieteiksim labākos galdiņus dārzā un vakara laikus. Rezervējiet ērti tiešsaistē vai zvaniet mums.",
      cta_band_button: "Rezervēt galdiņu",
    },
    about: {
      eyebrow: "Par restorānu",
      title: "Restorāns Roze",
      lead:
        "Itāļu virtuves restorāns vienā no labākajām vietām Liepājā – ziedošā dārzā, netālu no Baltijas jūras krasta.",
      p1:
        "Restorāns Roze atrodas pasakainā lokācijā pašā viesnīcas Roze Boutique Hotel sirdī – plašajā un ziedošajā dārzā. Šovasar virtuvē valda itāļu garša: mājās gatavota pasta, krāsnī cepta pica un mūsdienīgs Vidusjūras klasikas izpildījums.",
      p2:
        "Galvenais akcents tiek vērsts uz šarmanto ēdienu pasniegšanas veidu. Viesi izbauda nesteidzīgu vakariņu dārza gaisotnē, ko vasaras vakariem piešķir īpašu šarmu un Amalfi krasta noskaņu.",
      p3:
        "Restorāns ir atvērts viesnīcas viesiem un visiem pilsētas iedzīvotājiem no maija līdz septembrim.",
      facts_title: "Īsumā",
      facts: [
        { label: "Virtuve", value: "Itāļu, autora" },
        { label: "Sezona", value: "Maijs – septembris" },
        { label: "Atrašanās", value: "Roze Boutique Hotel dārzs" },
        { label: "Atmosfēra", value: "Amalfi vasara Liepājā" },
      ],
    },
    gallery: {
      eyebrow: "Galerija",
      title: "Atmosfēra un mirkļi",
      lead: "Caur citronu lapām, ziediem un Baltijas saulrietu.",
    },
    events: {
      eyebrow: "Pasākumi",
      title: "Bankets dārzā",
      lead:
        "Restorāns Roze piedāvā banketu un dažādu citu svinīgu pasākumu apkalpošanu un organizēšanu.",
      list: [
        {
          title: "Privātie banketi",
          body: "Kāzu vakari, jubilejas un ģimenes svinības dārzā līdz 80 viesiem.",
        },
        {
          title: "Korporatīvās vakariņas",
          body: "Eleganta vakara izrādes, vīna pāra un nelielas izklaides programmas.",
        },
        {
          title: "Sezonas vakari",
          body: "Vasaras šefpavāra galdi, dzīvā mūzika un dārzs zem zvaigznēm.",
        },
      ],
      cta_title: "Plānojat pasākumu?",
      cta_body:
        "Sazinieties ar mums, lai pārrunātu detaļas, izvēlni un datumu. Mēs sagatavosim individuālu piedāvājumu.",
      cta_button: "Pieteikt banketu",
      phone: "+371 26111722",
    },
    reviews: {
      eyebrow: "Ko saka mūsu viesi",
      title: "Atsauksmes",
      lead: "Pateicamies par jūsu uzticību. Dalieties iespaidos par savu vakaru pie mums.",
      based_on: "pamatojoties uz",
      based_on_suffix: "atsauksmēm",
      empty: "Vēl nav atsauksmju. Esi pirmais, kas atstāj iespaidu!",
      see_all: "Skatīt visas",
      leave_cta: "Atstāt atsauksmi",
      home_overline: "Mūsu viesi stāsta",
      home_title: "Iespaidi no dārza",
      home_cta: "Visas atsauksmes",
      anon: "Anonīms viesis",
      form: {
        title: "Atstāt atsauksmi",
        rating_label: "Jūsu vērtējums",
        rating_help: "Izvēlieties no 1 līdz 5 zvaigznēm",
        name_label: "Vārds (nav obligāts)",
        name_placeholder: "Kā vēlaties parakstīties",
        comment_label: "Komentārs",
        comment_placeholder: "Pastāstiet par savu pieredzi...",
        submit: "Publicēt atsauksmi",
        submitting: "Publicē...",
        success: "Paldies par jūsu atsauksmi!",
        error_rating: "Lūdzu, izvēlieties vērtējumu zvaigznēs.",
        error_comment: "Lūdzu, ierakstiet komentāru.",
        error_generic: "Diemžēl neizdevās. Mēģiniet vēlreiz.",
      },
    },
    contact: {
      eyebrow: "Kontakti",
      title: "Mūs atradīsiet šeit",
      address_label: "Adrese",
      address_value: "Rožu iela 37, Liepāja, Latvija",
      phone_label: "Tālrunis",
      hours_label: "Sezona",
      hours_value: "Maijs – Septembris, ik dienu 12:00 – 22:00",
      form_title: "Uzrakstiet mums",
      form: {
        name: "Vārds",
        email: "E-pasts",
        phone: "Tālrunis",
        subject: "Tēma",
        message: "Ziņojums",
        submit: "Nosūtīt",
        success: "Jūsu ziņa ir aizsūtīta!",
        error: "Diemžēl neizdevās nosūtīt. Mēģiniet vēlāk.",
      },
    },
    reserve: {
      eyebrow: "Rezervācija",
      title: "Rezervējiet savu galdiņu",
      lead:
        "Aizpildiet formu un mēs apstiprināsim rezervāciju pa tālruni vai e-pastu.",
      form: {
        date: "Datums",
        time: "Laiks",
        guests: "Viesu skaits",
        name: "Vārds",
        phone: "Tālrunis",
        email: "E-pasts",
        message: "Ziņa (nav obligāts)",
        message_placeholder: "Īpašs lūgums, alerģijas, vēlamais galdiņš...",
        submit: "Rezervēt",
        submitting: "Sūta...",
        success_title: "Jūsu ziņa ir aizsūtīta!",
        success_body:
          "Mēs sazināsimies ar Jums, lai apstiprinātu rezervāciju.",
        error: "Diemžēl neizdevās. Mēģiniet vēlreiz vai zvaniet mums.",
        select_date: "Izvēlieties datumu",
        select_time: "Izvēlieties laiku",
        select_guests: "Cik viesu?",
      },
    },
    menu: {
      eyebrow: "Ēdienkarte",
      title: "Vasaras itāļu ēdienkarte",
      lead:
        "Mājās gatavota pasta, krāsnī cepta pica un mūsdienīgs Vidusjūras klasikas izpildījums.",
      note: "Ēdienkarte var mainīties atkarībā no sezonas un dienas piedāvājuma. Lūdzam par alerģijām brīdināt iepriekš.",
      pizza_note: "Picu izvēli atjauninām katru sezonu — galīgo karti uzziniet restorānā.",
      currency: "€",
      allergens_label: "Alerģēni",
      allergens_legend_title: "Alerģēnu apzīmējumi",
      allergens_legend: [
        "1 — Lipekli saturoši graudaugi",
        "2 — Vēžveidīgie",
        "3 — Olas",
        "4 — Zivis",
        "5 — Zemesrieksti",
        "6 — Soja",
        "7 — Piens un piena produkti",
        "8 — Rieksti",
        "9 — Selerijas",
        "10 — Sinepes",
        "11 — Sezama sēklas",
        "12 — Sulfīti",
        "13 — Lupīna",
        "14 — Mīkstmieši",
      ],
      sections: [
        {
          key: "antipasti",
          title: "Antipasti",
          subtitle: "Uzkodas",
          items: [
            { name: "Gaspačo", desc: "Zemenes un stracciatella, tomāti.", price: 9, allergens: "7", image: "/menu-photos/gazpacho.webp" },
            { name: "Vitello Tonnato", desc: "Plāni sagriezta teļa gaļa, tunča mērce, kaperi, anšovi, olīveļļa.", price: 12, allergens: "4", image: "/menu-photos/vitello.webp" },
            { name: "Laša Crudo", desc: "Persiku salsa, vīnogas, sojas-vasabi mērce, medus.", price: 13, allergens: "4, 6", image: "/menu-photos/salmon_crudo.webp" },
            { name: "Gambas al Ajillo", desc: "Garneles, ķiploki, eļļa, saldā čili mērce.", price: 16, allergens: "1, 2", image: "/menu-photos/gambas_al_ajillo.webp" },
            { name: "Liellopa Tartars", desc: "Liellopa gaļa, brioša un aioli, trifeļu pasta.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/beef_tartare.webp" },
            { name: "Garneļu Karpačo", desc: "Mango garšvielas, avokado, sojas-vasabi mērce, koriandrs.", price: 16, allergens: "2, 6", image: "/menu-photos/prawn_carpaccio.webp" },
          ],
        },
        {
          key: "insalate",
          title: "Insalate",
          subtitle: "Salāti",
          items: [
            { name: "Cēzara salāti ar vistas Milanese", desc: "Kraukšķīga vista, salāti, parmezāns, grauzdiņi.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/caesar.webp" },
            { name: "Burrata Panzanella salāti", desc: "Burrata, ķiršu tomāti, itāļu garšvielas, kraukšķīga maize, olīveļļa.", price: 12, allergens: "1, 7", image: "/menu-photos/burrata.webp" },
            { name: "Salāti ar karamelizētu bumbieri", desc: "Gorgonzola, grauzdētas mandeles, vīnogas, medus mērce.", price: 13, allergens: "7, 8", image: "/menu-photos/pear_salad.webp" },
            { name: "Melone un Prosciutto", desc: "Gatava melone, plāni sagriezts prosciutto di parma.", price: 12, allergens: "—", image: "/menu-photos/melon_prosciutto.webp" },
          ],
        },
        {
          key: "pasta",
          title: "Pasta · Risotto",
          subtitle: "Pasta un Rizoto",
          items: [
            { name: "Tagliatelle Carbonara", desc: "Olas dzeltenums, parmezāns, bekons, melnie pipari.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/carbonara.webp" },
            { name: "Kartupeļu Gnocchi", desc: "Sēnes, zaļie zirnīši, sviests, garšaugi.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/gnocchi.webp" },
            { name: "Pasta ar Vongole un citronu", desc: "Spageti, vongoles, sviests, pētersīļi, ķiploki, citrona miziņa.", price: 15, allergens: "1, 7, 14", image: "/menu-photos/vongole.webp" },
            { name: "Pappardelle alla Bolognese", desc: "Lēni gatavots liellopu un cūkgaļas ragū ar tomātiem, garšaugiem un parmezānu.", price: 13, allergens: "1, 3, 7, 9", image: "/menu-photos/bolognese.webp" },
            { name: "Rigatoni al Tartufo", desc: "Krēmīga trifeļu mērce, parmezāns.", price: 14, allergens: "1, 7", image: "/menu-photos/rigatoni.webp" },
            { name: "Sēņu Risotto", desc: "Arborio rīsi, dažādas sēnes, parmezāns, sviests, garšaugi.", price: 14, allergens: "7", image: "/menu-photos/mushroom_risotto.webp" },
            { name: "Risotto ar karalisko garneli", desc: "Arborio rīsi, karaliskā garnele, ķiploki, baltvīns, pētersīļi, safrāns.", price: 19, allergens: "2, 7, 12", image: "/menu-photos/risotto_prawn.webp" },
          ],
        },
        {
          key: "secondi",
          title: "Pamatēdieni",
          subtitle: "Main Courses",
          items: [
            { name: "Jēra Karē", desc: "Demi-glace mērce, brokoļini.", price: 30, allergens: "7, 9, 12", image: "/menu-photos/lamb.webp" },
            { name: "Karaliskās garneles 3 gab. (Gamberi)", desc: "Tomātu vierge, sojas-vasabi mērce.", price: 28, allergens: "2, 6", image: "/menu-photos/king_prawns.webp" },
            { name: "Laša filejas steiks", desc: "Pasniegts ar artišokiem alla barigoule.", price: 20, allergens: "4, 9, 12", image: "/menu-photos/salmon_fillet.webp" },
            { name: "Klasiskā itāļu lazanja", desc: "Pastas kārtas, sugo di pomodoro, liellopa un cūkgaļas ragū, bešamela mērce, parmezāns.", price: 14, allergens: "1, 3, 7", image: "/menu-photos/lasagna.webp" },
            { name: "Paltusa fileja", desc: "Brokoļu biezenis, stracciatella siers, kaltēts tomāts, terijaki mērce.", price: 30, allergens: "4, 6, 7", image: "/menu-photos/halibut.webp" },
            { name: "Striploin steiks", desc: "Demi-glace mērce, brokoļini.", price: 35, allergens: "7, 9, 12", image: "/menu-photos/striploin.webp" },
            { name: "Teļa gaļas Milanese", desc: "Kraukšķīga teļa gaļas karbonāde ar jauktajiem salātiem un sugo di pomodoro.", price: 30, allergens: "1, 3, 7", image: "/menu-photos/veal_milanese.webp" },
            { name: "Grilēts astoņkājis", desc: "Romesco mērce, kraukšķīgi gnocchi.", price: 21, allergens: "1, 3, 8, 14", image: "/menu-photos/octopus.webp" },
            { name: "Vistas Krūtiņa ar Trifelēm", desc: "Vista, trifeļu mērce, sēnes, kartupeļu biezenis, zaļie zirnīši.", price: 19, allergens: "7", image: "/menu-photos/chicken_truffle.webp" },
          ],
        },
        {
          key: "grill",
          title: "Alla Brace",
          subtitle: "Šašliki",
          items: [
            { name: "Jēra Šašliks", desc: "Grilēti mini romiešu salāti, tkemali, marinēts sīpols, garšaugu mērce, pita.", price: 20, allergens: "1", image: "/menu-photos/lamb_shashlik.webp" },
            { name: "Cūkgaļas Šašliks", desc: "Gruzīnu čimičuri, jauktie salāti, pita maize.", price: 14, allergens: "1", image: "/menu-photos/pork_shashlik.webp" },
            { name: "Vistas Šašliks", desc: "Adžika un parmezāna majonēze, pita, grilēts laims.", price: 14, allergens: "1, 3, 7, 10", image: "/menu-photos/chicken_shashlik.webp" },
          ],
        },
        {
          key: "pizza",
          title: "Pizza",
          subtitle: "Krāsnī cepta",
          is_pizza: true,
          items: [
            { name: "Pizza Margherita", desc: "Tomātu mērce, mocarella, baziliks.", price: 12, allergens: "1, 7", image: "/menu-photos/pizza_margherita.webp" },
            { name: "Pizza Prosciutto Funghi", desc: "Prošuto, sēnes, mocarella, stracciatella siers, kaltēti tomāti, rukola.", price: 18, allergens: "1, 7", image: "/menu-photos/pizza_prosciutto.webp" },
            { name: "Pizza Salmone e Gamberetti", desc: "Tomātu mērce, mocarella, mazsālīts lasis, garneles, rukola, stracciatella, olīveļļa.", price: 18, allergens: "1, 2, 4, 7", image: "/menu-photos/pizza_salmone.webp" },
            { name: "Pizza Quattro Formaggi con Lardo", desc: "Gorgonzola, Grana Padano/parmezāns, brī, mocarella, oregano, špeķis.", price: 16, allergens: "1, 7", image: "/menu-photos/pizza_quattro.webp" },
            { name: "Pizza Burrata", desc: "Tomātu mērce, mocarella, burrata, salātu lapas, ķiršu tomāti, ciedru rieksti, parma, pesto mērce, krēms.", price: 20, allergens: "1, 7, 8", image: "/menu-photos/pizza_burrata.webp" },
            { name: "Pizza Diavola", desc: "Tomātu mērce, mocarella, pepperoni salami, čili pipari, baziliks.", price: 16, allergens: "1, 7", image: "/menu-photos/pizza_diavola.webp" },
            { name: "Pizza Mortadella", desc: "Krējuma mērce, mortadella, mozzarella, stracciatella, pesto un sasmalcināti pistāciju rieksti.", price: 19, allergens: "1, 7, 8", image: "/menu-photos/pizza_mortadella.webp" },
            { name: "Pizza Pollo e Pancetta", desc: "Mīkla, picas mērce, mozzarella, parmezāns, rikota, bekons, vista, cepti sīpoli, olīveļļa.", price: 18, allergens: "1, 7", image: "/menu-photos/pizza_pollo_pancetta.webp" },
            { name: "Pizza Frutti di Mare", desc: "Mīkla, picas mērce, astoņkājis, mozzarella, tīģergarneles, gliemenes, mango, kalmāri, ķiršu tomāti, koriandrs, olīveļļa.", price: 19, allergens: "1, 2, 7, 14", image: "/menu-photos/pizza_frutti_mare.webp" },
          ],
        },
        {
          key: "dolci",
          title: "Dolci",
          subtitle: "Deserti",
          items: [
            { name: "Klasiskais itāļu Tiramisu", desc: "Mascarpone, espresso mērcēti cepumi savoiardi, kakao.", price: 7, allergens: "1, 3, 7", image: "/menu-photos/tiramisu.webp" },
            { name: "Semifreddo al Gorgonzola", desc: "Gorgonzola, medus, karamelizēti valrieksti.", price: 7, allergens: "3, 7, 8", image: "/menu-photos/semifreddo.webp" },
            { name: "Citronu sorbets", desc: "Sorbets, citrons.", price: 6, allergens: "—", image: "/menu-photos/lemon_sorbet.webp" },
            { name: "Basku siera kūka", desc: "Krēmsiers, kukurūzas ciete, olas, vaniļas pasta, apelsīna miziņa, pūdercukurs, saldais krējums, šokolāde.", price: 8, allergens: "3, 7", image: "/menu-photos/basque_cheesecake.webp" },
          ],
        },
      ],
      wine: {
        page_title: "Vīna karte",
        eyebrow: "Vīna karte",
        title: "Vīna karte",
        lead: "Sezonāla itāļu, gruzīnu un Austrijas vīnu izlase. Cenas norādītas eiro: glāze / pudele.",
        note: "Pieejamība var mainīties atkarībā no sezonas. Pilnu sortimentu un palīdzību ar izvēli prasiet pie viesmīļa.",
        labels: {
          region: "Reģions",
          grape: "Šķirne",
          year: "Gads",
          volume: "Tilpums",
          glass_bottle: "Glāze / Pudele",
        },
        sections: {
          sparkling: { title: "Dzirkstošie vīni", subtitle: "Spumante & Champagne" },
          cider_pet_nat: { title: "Sidrs · Pet Nat", subtitle: "Cider · Pet Nat" },
          white: { title: "Baltvīns", subtitle: "Vini Bianchi" },
          rose: { title: "Sārtvīns", subtitle: "Vini Rosati" },
          amber: { title: "Dzintarvīns", subtitle: "Vini Ambrati" },
          red: { title: "Sarkanvīns", subtitle: "Vini Rossi" },
          dessert: { title: "Deserta vīni", subtitle: "Vini Dolci" },
        },
      },
      wine_link: "Skatīt vīna karti",
    },
    footer: {
      tagline: "Roze Boutique Hotel dārzā.",
      address: "Rožu iela 37, Liepāja, LV-3401",
      season: "Atvērts: Maijs – Septembris",
      rights: "Visas tiesības aizsargātas.",
      links_title: "Navigācija",
      contact_title: "Kontakti",
    },
    common: {
      reserve_now: "Rezervēt",
      call_us: "Zvanīt",
      learn_more: "Uzzināt vairāk",
    },
    marquee: [
      "La dolce vita",
      "Itāļu virtuve",
      "Pie Baltijas jūras",
      "Maijs – Septembris",
      "Liepāja, Latvija",
      "Šefpavāra rokraksts",
      "Buon appetito",
    ],
    press: {
      eyebrow: "Atsauksmes & prese",
      title: "Vārdi par mums",
      quotes: [
        {
          text:
            "Itālija nokāpa Liepājas vasarā – pasta, citroni un saulrieta noskaņa uz katra šķīvja.",
          author: "Diena · Restorānu apskate",
        },
        {
          text:
            "Vakars Roze dārzā šķiet kā vēstule no Amalfi – nesteidzīga un siltā.",
          author: "Latvijas Avīze",
        },
        {
          text:
            "Ja pasaule kādreiz pavadīs Liepājas vasaru, lai tā to dara šeit.",
          author: "Kurzemes Vārds",
        },
      ],
    },
    chef: {
      eyebrow: "Šefpavāre",
      title: "Roze ēdienkartes balss",
      body:
        "Mūsu šefpavāre rūpējas, lai katrs šķīvis runātu ar Vidusjūras vārdiem – vasaras klasika, mājās gatavota pasta un krāsnī cepta pica.",
      sign: "— Šefpavāre",
    },
    season_closed: {
      eyebrow: "Paziņojums",
      title: "Sezona ir noslēgusies",
      body:
        "Paldies visiem, kas šovasar dalījās ar mums vakariem dārzā. Restorāns Roze ir slēgts līdz nākamajai vasaras sezonai.",
      reopen: "Uz tikšanos 2027. gada maijā",
      cta: "Turpināt apskatīt",
      signature: "Ar mīlestību, Roze komanda",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      menu: "Menu",
      wine: "Wine list",
      gallery: "Gallery",
      events: "Events",
      reviews: "Reviews",
      contact: "Contact",
      reserve: "Book a table",
    },
    hero: {
      eyebrow: "An Italian summer restaurant in Liepāja",
      title_1: "Restaurant",
      title_2: "Roze",
      tagline:
        "Italian cuisine in a blooming garden, just steps from the Baltic sea — la dolce vita on the Liepāja shore.",
      cta_reserve: "Book a table",
      cta_about: "Discover the place",
      season: "Open from May to September",
    },
    home: {
      intro_overline: "Our story",
      intro_title: "An Italian summer in a Liepāja garden",
      intro_body_1:
        "Restaurant Roze rests in a fairy-tale spot – the wide and blooming garden of the Roze Boutique Hotel, in one of the most beautiful corners of Liepāja. This summer our kitchen speaks Italian.",
      intro_body_2:
        "On the menu: Italian classics with the chef's hand – fresh pasta, oven-baked pizza, truffle risotto and a slow Mediterranean evening under Latvian skies.",
      intro_cta: "More about the restaurant",
      highlights_overline: "Atmosphere",
      highlights_title: "An Italian taste in a Liepāja garden",
      highlights: [
        { title: "Blooming garden", body: "Cosy summer evenings among roses, greenery and the soft sound of the fountain." },
        { title: "Italian cuisine", body: "Hand-made pasta, oven-baked pizza and Mediterranean classics." },
        { title: "Close to the Baltic", body: "Minutes from the seashore — like an Amalfi coast in the north." },
      ],
      cta_band_overline: "Reservation",
      cta_band_title: "We've kept your table",
      cta_band_body:
        "We'll suggest the best garden tables and evening times. Reserve online or simply call us.",
      cta_band_button: "Book a table",
    },
    about: {
      eyebrow: "About",
      title: "Restaurant Roze",
      lead:
        "An Italian cuisine restaurant in one of the finest spots in Liepāja – a blooming garden close to the Baltic sea.",
      p1:
        "Restaurant Roze sits at the heart of the Roze Boutique Hotel – inside the wide, blooming garden. This summer the kitchen speaks Italian: house-made pasta, oven-baked pizza and a contemporary take on Mediterranean classics.",
      p2:
        "The accent falls on the charming way each plate is composed. Guests linger over an unhurried dinner in the garden, with summer's particular charm and a touch of the Amalfi coast holding the evening together.",
      p3:
        "The restaurant welcomes hotel guests and the people of the city alike from May through September.",
      facts_title: "At a glance",
      facts: [
        { label: "Cuisine", value: "Italian, author" },
        { label: "Season", value: "May – September" },
        { label: "Setting", value: "Roze Boutique Hotel garden" },
        { label: "Atmosphere", value: "Amalfi summer in Liepāja" },
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Moments and atmosphere",
      lead: "Through lemon leaves, blossoms and the slow Baltic sunset.",
    },
    events: {
      eyebrow: "Events",
      title: "Banquets in the garden",
      lead:
        "Restaurant Roze hosts banquets and other private gatherings, taking care of the entire arrangement.",
      list: [
        {
          title: "Private banquets",
          body: "Wedding evenings, anniversaries and family celebrations in the garden, up to 80 guests.",
        },
        {
          title: "Corporate dinners",
          body: "Elegant evenings, wine pairings and small-format entertainment.",
        },
        {
          title: "Seasonal evenings",
          body: "Chef's tables, live music and dinner under the stars.",
        },
      ],
      cta_title: "Planning an event?",
      cta_body:
        "Get in touch to discuss details, menu and date. We'll prepare an individual proposal.",
      cta_button: "Enquire about a banquet",
      phone: "+371 26111722",
    },
    reviews: {
      eyebrow: "What our guests say",
      title: "Reviews",
      lead: "Thank you for your trust. Share your impressions of an evening with us.",
      based_on: "based on",
      based_on_suffix: "reviews",
      empty: "No reviews yet. Be the first to leave one!",
      see_all: "See all",
      leave_cta: "Leave a review",
      home_overline: "Voices from the garden",
      home_title: "What guests are saying",
      home_cta: "All reviews",
      anon: "Anonymous guest",
      form: {
        title: "Leave a review",
        rating_label: "Your rating",
        rating_help: "Choose between 1 and 5 stars",
        name_label: "Name (optional)",
        name_placeholder: "How you'd like to sign",
        comment_label: "Comment",
        comment_placeholder: "Tell us about your experience...",
        submit: "Publish review",
        submitting: "Publishing...",
        success: "Thank you for your review!",
        error_rating: "Please choose a star rating.",
        error_comment: "Please write a short comment.",
        error_generic: "Could not submit. Please try again.",
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Find us here",
      address_label: "Address",
      address_value: "Rožu iela 37, Liepāja, Latvia",
      phone_label: "Phone",
      hours_label: "Season",
      hours_value: "May – September, daily 12:00 – 22:00",
      form_title: "Write to us",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        submit: "Send",
        success: "Your message has been sent!",
        error: "Something went wrong. Please try again later.",
      },
    },
    reserve: {
      eyebrow: "Reservation",
      title: "Reserve your table",
      lead:
        "Fill in the form and we will confirm your reservation by phone or email.",
      form: {
        date: "Date",
        time: "Time",
        guests: "Guests",
        name: "Name",
        phone: "Phone",
        email: "Email",
        message: "Message (optional)",
        message_placeholder: "Special request, allergies, preferred table...",
        submit: "Reserve",
        submitting: "Sending...",
        success_title: "Your message has been sent!",
        success_body: "We'll be in touch shortly to confirm your reservation.",
        error: "Something went wrong. Please try again or call us.",
        select_date: "Pick a date",
        select_time: "Pick a time",
        select_guests: "How many guests?",
      },
    },
    menu: {
      eyebrow: "Menu",
      title: "The summer Italian menu",
      lead:
        "House-made pasta, oven-baked pizza and a contemporary take on Mediterranean classics.",
      note: "The menu may vary by season and the day's offering. Please let us know about allergies in advance.",
      pizza_note: "Our pizza selection is updated each season — see the final list at the restaurant.",
      currency: "€",
      allergens_label: "Allergens",
      allergens_legend_title: "Allergen reference",
      allergens_legend: [
        "1 — Gluten-containing cereals",
        "2 — Crustaceans",
        "3 — Eggs",
        "4 — Fish",
        "5 — Peanuts",
        "6 — Soy",
        "7 — Milk & dairy",
        "8 — Tree nuts",
        "9 — Celery",
        "10 — Mustard",
        "11 — Sesame",
        "12 — Sulphites",
        "13 — Lupin",
        "14 — Molluscs",
      ],
      sections: [
        {
          key: "antipasti",
          title: "Antipasti",
          subtitle: "Starters",
          items: [
            { name: "Gazpacho", desc: "Strawberries and stracciatella, tomatoes.", price: 9, allergens: "7", image: "/menu-photos/gazpacho.webp" },
            { name: "Vitello Tonnato", desc: "Sliced veal, tuna sauce, capers, anchovy, olive oil.", price: 12, allergens: "4", image: "/menu-photos/vitello.webp" },
            { name: "Salmon Crudo", desc: "Peach salsa, grapes, soy-wasabi dressing, honey.", price: 13, allergens: "4, 6", image: "/menu-photos/salmon_crudo.webp" },
            { name: "Gambas al Ajillo", desc: "Prawns, garlic, oil, sweet chilli sauce.", price: 16, allergens: "1, 2", image: "/menu-photos/gambas_al_ajillo.webp" },
            { name: "Beef Tartare", desc: "Beef, brioche and aioli, truffle paste.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/beef_tartare.webp" },
            { name: "Prawn Carpaccio", desc: "Mango seasoning, avocado, soy-wasabi dressing, coriander.", price: 16, allergens: "2, 6", image: "/menu-photos/prawn_carpaccio.webp" },
          ],
        },
        {
          key: "insalate",
          title: "Insalate",
          subtitle: "Salads",
          items: [
            { name: "Chicken Milanese Caesar Salad", desc: "Crispy chicken, salad, parmesan, croutons.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/caesar.webp" },
            { name: "Burrata Panzanella Salad", desc: "Burrata, cherry tomatoes, Italian seasoning, crusty bread, olive oil.", price: 12, allergens: "1, 7", image: "/menu-photos/burrata.webp" },
            { name: "Caramelised Pear Salad", desc: "Gorgonzola, roasted almonds, grapes, honey dressing.", price: 13, allergens: "7, 8", image: "/menu-photos/pear_salad.webp" },
            { name: "Melon & Prosciutto", desc: "Ripe melon, thinly sliced prosciutto di parma.", price: 12, allergens: "—", image: "/menu-photos/melon_prosciutto.webp" },
          ],
        },
        {
          key: "pasta",
          title: "Pasta · Risotto",
          subtitle: "Pasta & Risotto",
          items: [
            { name: "Tagliatelle Carbonara", desc: "Egg yolk, parmesan, bacon, black pepper.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/carbonara.webp" },
            { name: "Potato Gnocchi", desc: "Mushrooms, green peas, butter, herbs.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/gnocchi.webp" },
            { name: "Pasta Vongole al Limone", desc: "Spaghetti, vongole clams, butter, parsley, garlic, lemon zest.", price: 15, allergens: "1, 7, 14", image: "/menu-photos/vongole.webp" },
            { name: "Pappardelle alla Bolognese", desc: "Slow-cooked beef and pork ragù with tomato, herbs and parmesan.", price: 13, allergens: "1, 3, 7, 9", image: "/menu-photos/bolognese.webp" },
            { name: "Rigatoni al Tartufo", desc: "Creamy truffle sauce, parmesan.", price: 14, allergens: "1, 7", image: "/menu-photos/rigatoni.webp" },
            { name: "Mushroom Risotto", desc: "Arborio rice, mixed mushrooms, parmesan, butter, herbs.", price: 14, allergens: "7", image: "/menu-photos/mushroom_risotto.webp" },
            { name: "Risotto with King Prawn", desc: "Arborio rice, king prawn, garlic, white wine, parsley, saffron.", price: 19, allergens: "2, 7, 12", image: "/menu-photos/risotto_prawn.webp" },
          ],
        },
        {
          key: "secondi",
          title: "Main Courses",
          subtitle: "Pamatēdieni",
          items: [
            { name: "Rack of Lamb", desc: "Demi-glace sauce, broccolini.", price: 30, allergens: "7, 9, 12", image: "/menu-photos/lamb.webp" },
            { name: "King Prawns 3 pcs (Gamberi)", desc: "Tomato vierge, soy-wasabi dressing.", price: 28, allergens: "2, 6", image: "/menu-photos/king_prawns.webp" },
            { name: "Salmon Fillet Steak", desc: "Served with artichoke alla barigoule.", price: 20, allergens: "4, 9, 12", image: "/menu-photos/salmon_fillet.webp" },
            { name: "Classic Italian Lasagna", desc: "Layers of pasta, sugo di pomodoro, beef & pork ragù, béchamel, parmesan.", price: 14, allergens: "1, 3, 7", image: "/menu-photos/lasagna.webp" },
            { name: "Halibut Fillet", desc: "Broccoli purée, stracciatella, sun-dried tomato, teriyaki sauce.", price: 30, allergens: "4, 6, 7", image: "/menu-photos/halibut.webp" },
            { name: "Striploin Steak", desc: "Demi-glace sauce, broccolini.", price: 35, allergens: "7, 9, 12", image: "/menu-photos/striploin.webp" },
            { name: "Veal Milanese", desc: "Crispy veal cutlet with mixed salad and sugo di pomodoro.", price: 30, allergens: "1, 3, 7", image: "/menu-photos/veal_milanese.webp" },
            { name: "Grilled Octopus", desc: "Romesco sauce, crispy gnocchi.", price: 21, allergens: "1, 3, 8, 14", image: "/menu-photos/octopus.webp" },
            { name: "Chicken Breast with Truffle", desc: "Chicken, truffle sauce, mushrooms, mashed potatoes, green peas.", price: 19, allergens: "7", image: "/menu-photos/chicken_truffle.webp" },
          ],
        },
        {
          key: "grill",
          title: "Alla Brace",
          subtitle: "Shashlik",
          items: [
            { name: "Lamb Shashlik", desc: "Grilled mini romano, tkemali, marinated onion, herb sauce, pita.", price: 20, allergens: "1", image: "/menu-photos/lamb_shashlik.webp" },
            { name: "Pork Shashlik", desc: "Georgian chimichurri, mixed salad, pita bread.", price: 14, allergens: "1", image: "/menu-photos/pork_shashlik.webp" },
            { name: "Chicken Shashlik", desc: "Adjika and parmesan mayonnaise, pita, grilled lime.", price: 14, allergens: "1, 3, 7, 10", image: "/menu-photos/chicken_shashlik.webp" },
          ],
        },
        {
          key: "pizza",
          title: "Pizza",
          subtitle: "Wood-oven pizza",
          is_pizza: true,
          items: [
            { name: "Pizza Margherita", desc: "Tomato sauce, mozzarella, basil.", price: 12, allergens: "1, 7", image: "/menu-photos/pizza_margherita.webp" },
            { name: "Pizza Prosciutto Funghi", desc: "Prosciutto, mushrooms, mozzarella, stracciatella, sun-dried tomatoes, arugula.", price: 18, allergens: "1, 7", image: "/menu-photos/pizza_prosciutto.webp" },
            { name: "Pizza Salmone e Gamberetti", desc: "Tomato, mozzarella, lightly salted salmon, prawns, arugula, stracciatella, olive oil.", price: 18, allergens: "1, 2, 4, 7", image: "/menu-photos/pizza_salmone.webp" },
            { name: "Pizza Quattro Formaggi con Lardo", desc: "Gorgonzola, Grana Padano/parmesan, brie, mozzarella, oregano, speck.", price: 16, allergens: "1, 7", image: "/menu-photos/pizza_quattro.webp" },
            { name: "Pizza Burrata", desc: "Tomato, mozzarella, burrata, salad leaves, cherry tomatoes, pine nuts, parma, pesto, cream.", price: 20, allergens: "1, 7, 8", image: "/menu-photos/pizza_burrata.webp" },
            { name: "Pizza Diavola", desc: "Tomato sauce, mozzarella, pepperoni salami, chili pepper, basil.", price: 16, allergens: "1, 7", image: "/menu-photos/pizza_diavola.webp" },
            { name: "Pizza Mortadella", desc: "Cream sauce, mortadella, mozzarella, stracciatella, pesto and crushed pistachios.", price: 19, allergens: "1, 7, 8", image: "/menu-photos/pizza_mortadella.webp" },
            { name: "Pizza Pollo e Pancetta", desc: "Dough, pizza sauce, mozzarella, parmesan, ricotta, bacon, chicken, fried onion, olive oil.", price: 18, allergens: "1, 7", image: "/menu-photos/pizza_pollo_pancetta.webp" },
            { name: "Pizza Frutti di Mare", desc: "Dough, pizza sauce, octopus, mozzarella, tiger prawns, mussels, mango, squid, cherry tomatoes, coriander, olive oil.", price: 19, allergens: "1, 2, 7, 14", image: "/menu-photos/pizza_frutti_mare.webp" },
          ],
        },
        {
          key: "dolci",
          title: "Dolci",
          subtitle: "Desserts",
          items: [
            { name: "Classic Italian Tiramisu", desc: "Mascarpone, espresso-soaked ladyfingers, cocoa.", price: 7, allergens: "1, 3, 7", image: "/menu-photos/tiramisu.webp" },
            { name: "Semifreddo al Gorgonzola", desc: "Gorgonzola, honey, caramelised walnuts.", price: 7, allergens: "3, 7, 8", image: "/menu-photos/semifreddo.webp" },
            { name: "Lemon Sorbet", desc: "Sorbet, lemon.", price: 6, allergens: "—", image: "/menu-photos/lemon_sorbet.webp" },
            { name: "Basque Cheesecake", desc: "Cream cheese, corn starch, eggs, vanilla paste, orange zest, powdered sugar, heavy cream, chocolate.", price: 8, allergens: "3, 7", image: "/menu-photos/basque_cheesecake.webp" },
          ],
        },
      ],
      wine: {
        page_title: "Wine list",
        eyebrow: "Wine list",
        title: "Wine list",
        lead: "A seasonal selection of Italian, Georgian and Austrian wines. Prices in euros: glass / bottle.",
        note: "Availability may vary by season. Ask your server for the full selection and pairing advice.",
        labels: {
          region: "Region",
          grape: "Grape",
          year: "Year",
          volume: "Volume",
          glass_bottle: "Glass / Bottle",
        },
        sections: {
          sparkling: { title: "Sparkling", subtitle: "Spumante & Champagne" },
          cider_pet_nat: { title: "Cider · Pet Nat", subtitle: "Cider · Pet Nat" },
          white: { title: "White wine", subtitle: "Vini Bianchi" },
          rose: { title: "Rosé wine", subtitle: "Vini Rosati" },
          amber: { title: "Amber wine", subtitle: "Vini Ambrati" },
          red: { title: "Red wine", subtitle: "Vini Rossi" },
          dessert: { title: "Dessert wine", subtitle: "Vini Dolci" },
        },
      },
      wine_link: "View wine list",
    },
    footer: {
      tagline: "Roze Boutique Hotel garden.",
      address: "Rožu iela 37, Liepāja, LV-3401",
      season: "Open: May – September",
      rights: "All rights reserved.",
      links_title: "Navigation",
      contact_title: "Contact",
    },
    common: {
      reserve_now: "Book",
      call_us: "Call",
      learn_more: "Learn more",
    },
    marquee: [
      "La dolce vita",
      "Italian cuisine",
      "By the Baltic sea",
      "May – September",
      "Liepāja, Latvia",
      "Chef's signature",
      "Buon appetito",
    ],
    press: {
      eyebrow: "Words & press",
      title: "Said about us",
      quotes: [
        {
          text:
            "Italy stepped into Liepāja's summer — pasta, lemons and the mood of sunset on every plate.",
          author: "Diena · Restaurant review",
        },
        {
          text:
            "An evening in the Roze garden reads like a letter from Amalfi — unhurried and warm.",
          author: "Latvijas Avīze",
        },
        {
          text:
            "If the world is ever to spend a Liepāja summer, let it spend it here.",
          author: "Kurzemes Vārds",
        },
      ],
    },
    chef: {
      eyebrow: "The chef",
      title: "The voice of our menu",
      body:
        "Our chef makes sure every plate speaks the words of the Mediterranean — summer classics, hand-made pasta and oven-baked pizza.",
      sign: "— The chef",
    },
    season_closed: {
      eyebrow: "Announcement",
      title: "The season has come to a close",
      body:
        "Thank you to everyone who shared summer evenings in our garden with us. Restaurant Roze is closed until the next summer season.",
      reopen: "See you in May 2027",
      cta: "Continue browsing",
      signature: "With love, the Roze team",
    },
  },
  ru: {
    nav: {
      home: "Главная",
      about: "О нас",
      menu: "Меню",
      wine: "Винная карта",
      gallery: "Галерея",
      events: "События",
      reviews: "Отзывы",
      contact: "Контакты",
      reserve: "Забронировать столик",
    },
    hero: {
      eyebrow: "Итальянский летний ресторан в Лиепае",
      title_1: "Ресторан",
      title_2: "Roze",
      tagline:
        "Итальянская кухня в цветущем саду, в нескольких шагах от Балтийского моря — la dolce vita на лиепайском побережье.",
      cta_reserve: "Забронировать столик",
      cta_about: "Узнать о месте",
      season: "Открыт с мая по сентябрь",
    },
    home: {
      intro_overline: "Наша история",
      intro_title: "Итальянское лето в саду Лиепаи",
      intro_body_1:
        "Ресторан Roze расположен в волшебном месте — просторном цветущем саду отеля Roze Boutique Hotel, в одном из самых красивых уголков Лиепаи. Этим летом наша кухня говорит по-итальянски.",
      intro_body_2:
        "В летнем меню — итальянская классика с авторским почерком: домашняя паста, пицца из печи, ризотто с трюфелем и неспешные средиземноморские вечера под латвийским небом.",
      intro_cta: "Подробнее о ресторане",
      highlights_overline: "Атмосфера",
      highlights_title: "Итальянский вкус в саду Лиепаи",
      highlights: [
        { title: "Цветущий сад", body: "Уютные летние вечера среди роз, зелени и тихого шума фонтана." },
        { title: "Итальянская кухня", body: "Домашняя паста, пицца из печи и средиземноморская классика." },
        { title: "Балтика рядом", body: "Несколько минут до моря — будто Амальфи на севере." },
      ],
      cta_band_overline: "Бронирование",
      cta_band_title: "Стол ждёт вас",
      cta_band_body:
        "Мы подскажем лучшие столики в саду и удобное время. Бронируйте онлайн или позвоните нам.",
      cta_band_button: "Забронировать столик",
    },
    about: {
      eyebrow: "О ресторане",
      title: "Ресторан Roze",
      lead:
        "Ресторан итальянской кухни в одном из лучших мест Лиепаи — в цветущем саду неподалёку от Балтийского моря.",
      p1:
        "Ресторан Roze расположен в сказочном месте — в самом сердце отеля Roze Boutique Hotel, в просторном цветущем саду. Этим летом на кухне правит итальянский вкус: домашняя паста, пицца из печи и современное прочтение средиземноморской классики.",
      p2:
        "Главный акцент — на изящной подаче блюд. Гости наслаждаются неспешным ужином в саду, в атмосфере летнего вечера с нотками побережья Амальфи.",
      p3:
        "Ресторан открыт для гостей отеля и жителей города с мая по сентябрь.",
      facts_title: "Кратко",
      facts: [
        { label: "Кухня", value: "Итальянская, авторская" },
        { label: "Сезон", value: "Май – сентябрь" },
        { label: "Локация", value: "Сад Roze Boutique Hotel" },
        { label: "Атмосфера", value: "Амальфийское лето в Лиепае" },
      ],
    },
    gallery: {
      eyebrow: "Галерея",
      title: "Атмосфера и мгновения",
      lead: "Сквозь лимонные листья, цветение и неторопливый закат Балтики.",
    },
    events: {
      eyebrow: "События",
      title: "Банкеты в саду",
      lead:
        "Ресторан Roze проводит банкеты и другие торжественные мероприятия, заботясь обо всех деталях.",
      list: [
        {
          title: "Частные банкеты",
          body: "Свадьбы, юбилеи и семейные праздники в саду до 80 гостей.",
        },
        {
          title: "Корпоративные ужины",
          body: "Элегантные вечера, винные пары и камерные программы.",
        },
        {
          title: "Сезонные вечера",
          body: "Столы шеф-повара, живая музыка и ужины под звёздами.",
        },
      ],
      cta_title: "Планируете мероприятие?",
      cta_body:
        "Свяжитесь с нами, чтобы обсудить детали, меню и дату. Мы подготовим индивидуальное предложение.",
      cta_button: "Заявка на банкет",
      phone: "+371 26111722",
    },
    reviews: {
      eyebrow: "Что говорят наши гости",
      title: "Отзывы",
      lead: "Благодарим за доверие. Поделитесь впечатлениями о вечере у нас.",
      based_on: "на основании",
      based_on_suffix: "отзывов",
      empty: "Пока нет отзывов. Будьте первым!",
      see_all: "Смотреть все",
      leave_cta: "Оставить отзыв",
      home_overline: "Голоса из сада",
      home_title: "Что говорят гости",
      home_cta: "Все отзывы",
      anon: "Анонимный гость",
      form: {
        title: "Оставить отзыв",
        rating_label: "Ваша оценка",
        rating_help: "Выберите от 1 до 5 звёзд",
        name_label: "Имя (необязательно)",
        name_placeholder: "Как подписать отзыв",
        comment_label: "Комментарий",
        comment_placeholder: "Расскажите о вашем визите...",
        submit: "Опубликовать отзыв",
        submitting: "Публикуется...",
        success: "Спасибо за ваш отзыв!",
        error_rating: "Пожалуйста, выберите оценку звёздами.",
        error_comment: "Пожалуйста, напишите комментарий.",
        error_generic: "Не удалось отправить. Попробуйте ещё раз.",
      },
    },
    contact: {
      eyebrow: "Контакты",
      title: "Мы здесь",
      address_label: "Адрес",
      address_value: "Rožu iela 37, Лиепая, Латвия",
      phone_label: "Телефон",
      hours_label: "Сезон",
      hours_value: "Май – сентябрь, ежедневно 12:00 – 22:00",
      form_title: "Напишите нам",
      form: {
        name: "Имя",
        email: "Email",
        phone: "Телефон",
        subject: "Тема",
        message: "Сообщение",
        submit: "Отправить",
        success: "Ваше сообщение отправлено!",
        error: "Не удалось отправить. Попробуйте позже.",
      },
    },
    reserve: {
      eyebrow: "Бронирование",
      title: "Забронируйте столик",
      lead:
        "Заполните форму, и мы подтвердим бронирование по телефону или e-mail.",
      form: {
        date: "Дата",
        time: "Время",
        guests: "Гости",
        name: "Имя",
        phone: "Телефон",
        email: "Email",
        message: "Сообщение (необязательно)",
        message_placeholder: "Особое пожелание, аллергии, предпочитаемый столик...",
        submit: "Забронировать",
        submitting: "Отправляем...",
        success_title: "Ваше сообщение отправлено!",
        success_body: "Мы свяжемся с вами в ближайшее время для подтверждения.",
        error: "Не удалось отправить. Попробуйте снова или позвоните нам.",
        select_date: "Выберите дату",
        select_time: "Выберите время",
        select_guests: "Сколько гостей?",
      },
    },
    menu: {
      eyebrow: "Меню",
      title: "Летнее итальянское меню",
      lead:
        "Домашняя паста, пицца из печи и современное прочтение средиземноморской классики.",
      note: "Меню может меняться в зависимости от сезона и предложения дня. Об аллергиях, пожалуйста, предупредите заранее.",
      pizza_note: "Карта пицц обновляется каждый сезон — финальный список — в ресторане.",
      currency: "€",
      allergens_label: "Аллергены",
      allergens_legend_title: "Расшифровка аллергенов",
      allergens_legend: [
        "1 — Злаки с глютеном",
        "2 — Ракообразные",
        "3 — Яйца",
        "4 — Рыба",
        "5 — Арахис",
        "6 — Соя",
        "7 — Молоко и молочные продукты",
        "8 — Орехи",
        "9 — Сельдерей",
        "10 — Горчица",
        "11 — Кунжут",
        "12 — Сульфиты",
        "13 — Люпин",
        "14 — Моллюски",
      ],
      sections: [
        {
          key: "antipasti",
          title: "Antipasti",
          subtitle: "Закуски",
          items: [
            { name: "Гаспачо", desc: "Клубника и страчателла, помидоры.", price: 9, allergens: "7", image: "/menu-photos/gazpacho.webp" },
            { name: "Вителло тоннато", desc: "Тонко нарезанная телятина, соус из тунца, каперсы, анчоусы, оливковое масло.", price: 12, allergens: "4", image: "/menu-photos/vitello.webp" },
            { name: "Крудо из лосося", desc: "Сальса из персика, виноград, соево-васаби соус, мёд.", price: 13, allergens: "4, 6", image: "/menu-photos/salmon_crudo.webp" },
            { name: "Креветки в чесночном масле", desc: "Креветки, чеснок, масло, сладкий чили соус.", price: 16, allergens: "1, 2", image: "/menu-photos/gambas_al_ajillo.webp" },
            { name: "Тартар из говядины", desc: "Говядина, бриошь и айоли, трюфельная паста.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/beef_tartare.webp" },
            { name: "Карпаччо из креветок", desc: "Приправа из манго, авокадо, соево-васаби соус, кориандр.", price: 16, allergens: "2, 6", image: "/menu-photos/prawn_carpaccio.webp" },
          ],
        },
        {
          key: "insalate",
          title: "Insalate",
          subtitle: "Салаты",
          items: [
            { name: "Салат Цезарь с курицей Миланезе", desc: "Хрустящая курица, салат, пармезан, крутоны.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/caesar.webp" },
            { name: "Салат Панцанелла с Бурратой", desc: "Буррата, томаты черри, итальянские специи, хрустящий хлеб, оливковое масло.", price: 12, allergens: "1, 7", image: "/menu-photos/burrata.webp" },
            { name: "Салат с карамелизированной грушей", desc: "Горгонзола, жареный миндаль, виноград, медовая заправка.", price: 13, allergens: "7, 8", image: "/menu-photos/pear_salad.webp" },
            { name: "Дыня и Прошутто", desc: "Спелая дыня, тонко нарезанный прошутто ди парма.", price: 12, allergens: "—", image: "/menu-photos/melon_prosciutto.webp" },
          ],
        },
        {
          key: "pasta",
          title: "Pasta · Risotto",
          subtitle: "Паста и Ризотто",
          items: [
            { name: "Тальятелле Карбонара", desc: "Яичный желток, пармезан, бекон, чёрный перец.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/carbonara.webp" },
            { name: "Картофельные Ньокки", desc: "Грибы, зелёный горошек, сливочное масло, зелень.", price: 13, allergens: "1, 3, 7", image: "/menu-photos/gnocchi.webp" },
            { name: "Паста Вонголе с лимоном", desc: "Спагетти, вонголе, сливочное масло, петрушка, чеснок, лимонная цедра.", price: 15, allergens: "1, 7, 14", image: "/menu-photos/vongole.webp" },
            { name: "Паппарделле Болоньезе", desc: "Томлёное рагу из говядины и свинины с томатами, зеленью и сыром пармезан.", price: 13, allergens: "1, 3, 7, 9", image: "/menu-photos/bolognese.webp" },
            { name: "Ригатони Тартуфо", desc: "Сливочный трюфельный соус, пармезан.", price: 14, allergens: "1, 7", image: "/menu-photos/rigatoni.webp" },
            { name: "Ризотто с грибами", desc: "Рис арборио, смесь грибов, пармезан, сливочное масло, зелень.", price: 14, allergens: "7", image: "/menu-photos/mushroom_risotto.webp" },
            { name: "Ризотто с королевской креветкой", desc: "Рис арборио, королевская креветка, чеснок, белое вино, петрушка, шафран.", price: 19, allergens: "2, 7, 12", image: "/menu-photos/risotto_prawn.webp" },
          ],
        },
        {
          key: "secondi",
          title: "Главные блюда",
          subtitle: "Main Courses",
          items: [
            { name: "Каре ягнёнка", desc: "Соус демиглас, брокколини.", price: 30, allergens: "7, 9, 12", image: "/menu-photos/lamb.webp" },
            { name: "Королевские креветки 3 шт. (Gamberi)", desc: "Томатный vierge, соево-васаби соус.", price: 28, allergens: "2, 6", image: "/menu-photos/king_prawns.webp" },
            { name: "Стейк из филе лосося", desc: "Подаётся с артишоками alla barigoule.", price: 20, allergens: "4, 9, 12", image: "/menu-photos/salmon_fillet.webp" },
            { name: "Классическая итальянская лазанья", desc: "Слои пасты, сугу ди помодоро, рагу из говядины и свинины, бешамель, пармезан.", price: 14, allergens: "1, 3, 7", image: "/menu-photos/lasagna.webp" },
            { name: "Филе палтуса", desc: "Пюре из брокколи, страчателла, вяленый томат, соус терияки.", price: 30, allergens: "4, 6, 7", image: "/menu-photos/halibut.webp" },
            { name: "Стриплойн стейк", desc: "Соус демиглас, брокколини.", price: 35, allergens: "7, 9, 12", image: "/menu-photos/striploin.webp" },
            { name: "Телятина Миланезе", desc: "Хрустящая телячья котлета с миксом салатов и сугу ди помодоро.", price: 30, allergens: "1, 3, 7", image: "/menu-photos/veal_milanese.webp" },
            { name: "Осьминог на гриле", desc: "Соус ромеско, хрустящие ньокки.", price: 21, allergens: "1, 3, 8, 14", image: "/menu-photos/octopus.webp" },
            { name: "Куриная грудка с трюфелем", desc: "Курица, соус из трюфеля, грибы, картофельное пюре, зелёный горошек.", price: 19, allergens: "7", image: "/menu-photos/chicken_truffle.webp" },
          ],
        },
        {
          key: "grill",
          title: "Alla Brace",
          subtitle: "Шашлыки",
          items: [
            { name: "Шашлык из баранины", desc: "Гриль мини-ромэно, ткемали, маринованный лук, травяной соус, пита.", price: 20, allergens: "1", image: "/menu-photos/lamb_shashlik.webp" },
            { name: "Шашлык из свинины", desc: "Грузинский чимичури, микс салатов, пита.", price: 14, allergens: "1", image: "/menu-photos/pork_shashlik.webp" },
            { name: "Шашлык из курицы", desc: "Аджика и майонез с пармезаном, пита, гриль-лайм.", price: 14, allergens: "1, 3, 7, 10", image: "/menu-photos/chicken_shashlik.webp" },
          ],
        },
        {
          key: "pizza",
          title: "Pizza",
          subtitle: "Из дровяной печи",
          is_pizza: true,
          items: [
            { name: "Пицца Маргарита", desc: "Томатный соус, моцарелла, базилик.", price: 12, allergens: "1, 7", image: "/menu-photos/pizza_margherita.webp" },
            { name: "Пицца Prosciutto Funghi", desc: "Прошутто, грибы, моцарелла, страчателла, вяленые томаты, руккола.", price: 18, allergens: "1, 7", image: "/menu-photos/pizza_prosciutto.webp" },
            { name: "Пицца Salmone e Gamberetti", desc: "Томатный соус, моцарелла, малосольный лосось, креветки, руккола, страчателла, оливковое масло.", price: 18, allergens: "1, 2, 4, 7", image: "/menu-photos/pizza_salmone.webp" },
            { name: "Пицца Quattro Formaggi con Lardo", desc: "Горгонзола, Грана Падано/пармезан, бри, моцарелла, орегано, шпек.", price: 16, allergens: "1, 7", image: "/menu-photos/pizza_quattro.webp" },
            { name: "Пицца Burrata", desc: "Томат, моцарелла, буррата, листья салата, томаты черри, кедровые орехи, парма, соус песто, крем.", price: 20, allergens: "1, 7, 8", image: "/menu-photos/pizza_burrata.webp" },
            { name: "Пицца Diavola", desc: "Томатный соус, моцарелла, салями пепперони, перец чили, базилик.", price: 16, allergens: "1, 7", image: "/menu-photos/pizza_diavola.webp" },
            { name: "Пицца Mortadella", desc: "Сливочный соус, мортаделла, моцарелла, страчателла, песто и дроблёные фисташки.", price: 19, allergens: "1, 7, 8", image: "/menu-photos/pizza_mortadella.webp" },
            { name: "Пицца Pollo e Pancetta", desc: "Тесто, соус для пиццы, моцарелла, пармезан, рикотта, бекон, курица, жареный лук, оливковое масло.", price: 18, allergens: "1, 7", image: "/menu-photos/pizza_pollo_pancetta.webp" },
            { name: "Пицца Frutti di Mare", desc: "Тесто, соус для пиццы, осьминог, моцарелла, тигровые креветки, мидии, манго, кальмары, томаты черри, кинза, оливковое масло.", price: 19, allergens: "1, 2, 7, 14", image: "/menu-photos/pizza_frutti_mare.webp" },
          ],
        },
        {
          key: "dolci",
          title: "Dolci",
          subtitle: "Десерты",
          items: [
            { name: "Классический итальянский Тирамису", desc: "Маскарпоне, печенье савоярди, пропитанное эспрессо, какао.", price: 7, allergens: "1, 3, 7", image: "/menu-photos/tiramisu.webp" },
            { name: "Семифреддо с Горгонзолой", desc: "Горгонзола, мёд, карамелизированные грецкие орехи.", price: 7, allergens: "3, 7, 8", image: "/menu-photos/semifreddo.webp" },
            { name: "Лимонный сорбет", desc: "Сорбет, лимон.", price: 6, allergens: "—", image: "/menu-photos/lemon_sorbet.webp" },
            { name: "Баскский чизкейк", desc: "Сливочный сыр, кукурузный крахмал, яйца, ванильная паста, цедра апельсина, сахарная пудра, жирные сливки, шоколад.", price: 8, allergens: "3, 7", image: "/menu-photos/basque_cheesecake.webp" },
          ],
        },
      ],
      wine: {
        page_title: "Винная карта",
        eyebrow: "Винная карта",
        title: "Винная карта",
        lead: "Сезонная подборка итальянских, грузинских и австрийских вин. Цены в евро: бокал / бутылка.",
        note: "Доступность может меняться в зависимости от сезона. Полный ассортимент и советы по сочетанию — у официанта.",
        labels: {
          region: "Регион",
          grape: "Сорт",
          year: "Год",
          volume: "Объём",
          glass_bottle: "Бокал / Бутылка",
        },
        sections: {
          sparkling: { title: "Игристое", subtitle: "Spumante & Champagne" },
          cider_pet_nat: { title: "Сидр · Pet Nat", subtitle: "Cider · Pet Nat" },
          white: { title: "Белое вино", subtitle: "Vini Bianchi" },
          rose: { title: "Розовое вино", subtitle: "Vini Rosati" },
          amber: { title: "Янтарное вино", subtitle: "Vini Ambrati" },
          red: { title: "Красное вино", subtitle: "Vini Rossi" },
          dessert: { title: "Десертные вина", subtitle: "Vini Dolci" },
        },
      },
      wine_link: "Открыть винную карту",
    },
    footer: {
      tagline: "В саду Roze Boutique Hotel.",
      address: "Rožu iela 37, Лиепая, LV-3401",
      season: "Открыт: май – сентябрь",
      rights: "Все права защищены.",
      links_title: "Навигация",
      contact_title: "Контакты",
    },
    common: {
      reserve_now: "Бронь",
      call_us: "Позвонить",
      learn_more: "Подробнее",
    },
    marquee: [
      "La dolce vita",
      "Итальянская кухня",
      "У Балтийского моря",
      "Май – сентябрь",
      "Лиепая, Латвия",
      "Почерк шеф-повара",
      "Buon appetito",
    ],
    press: {
      eyebrow: "Отзывы & пресса",
      title: "Слова о нас",
      quotes: [
        {
          text:
            "Италия пришла в лиепайское лето — паста, лимоны и настроение заката на каждой тарелке.",
          author: "Diena · обзор ресторанов",
        },
        {
          text:
            "Вечер в саду Roze читается как письмо с Амальфи — неспешно и тепло.",
          author: "Latvijas Avīze",
        },
        {
          text:
            "Если миру однажды доведётся провести лиепайское лето — пусть проведёт его здесь.",
          author: "Kurzemes Vārds",
        },
      ],
    },
    chef: {
      eyebrow: "Шеф-повар",
      title: "Голос нашего меню",
      body:
        "Наш шеф следит, чтобы каждая тарелка говорила средиземноморским языком — летняя классика, домашняя паста и пицца из дровяной печи.",
      sign: "— Шеф-повар",
    },
    season_closed: {
      eyebrow: "Объявление",
      title: "Сезон завершён",
      body:
        "Благодарим всех, кто разделил с нами летние вечера в саду. Ресторан Roze закрыт до следующего летнего сезона.",
      reopen: "До встречи в мае 2027 года",
      cta: "Продолжить просмотр",
      signature: "С любовью, команда Roze",
    },
  },
};

export const supportedLanguages = ["lv", "en", "ru"];
